import ProgressScale from "../Components/UI/ProgressScale";
import "chart.js/auto";
import StyledButton from "../Components/UI/StyledButton";
import ReactLoading from "react-loading";
import { useEffect, useState } from "react";
import TestApi from "../Api/TestApi";
import TestBlock from "../Components/Modules/Test/TestBlock";
import FinalPopUp from "../Components/Modules/Test/FinalPopUp";
import { directus } from "../Api/FetchDirectus";
import { createItem } from "@directus/sdk";
import { useNavigate } from "react-router-dom";

const ModuleTestPage = () => {
  const navigate = useNavigate();
  const moduleInfo = JSON.parse(localStorage.getItem("module_files") || "[]");
  const [unlockNext, setUnlockNext] = useState(false);
  const [loader, setLoader] = useState(false);
  const [questionData, setQuestionData] = useState(
    JSON.parse(localStorage.getItem("question") || "{}") || null
  );
  const [chosenAnswerID, setChosenAnswerID] = useState([]);
  const [finalOpen, setFinalOpen] = useState(false);
  const [testCount, setTestCount] = useState(
    Number(localStorage.getItem("test_count")) || 1
  );
  const maxScore = JSON.parse(localStorage.getItem("maxScore") || "0");
  const [score, setScore] = useState(0);
  const [passed, setPassed] = useState(false);
  const age = localStorage.getItem("age");
  const gender = localStorage.getItem("gender");
  const activity = localStorage.getItem("activity");
  const position = localStorage.getItem("position");

  function addToStructure(
    structure: {
      [courseId: string]: {
        [moduleId: string]: string;
      };
    },
    moduleInfo: {
      course_id: string;
      id: string;
    }
  ) {
    if (!structure[moduleInfo.course_id]) {
      structure[moduleInfo.course_id] = {};
    }

    if (!structure[moduleInfo.course_id][moduleInfo.id]) {
      structure[moduleInfo.course_id][moduleInfo.id] = "";
    }
  }

  async function onNextTest() {
    const data = {
      session_code: localStorage.getItem("session_code") || "",
      question_id: questionData.question.id,
      selected_answer_ids: chosenAnswerID,
    };

    setLoader(true);
    const nextTest = await TestApi.nextTest(data);

    setScore(nextTest.scores[0].category_score);

    if (nextTest.message === "Quiz completed") {
      setFinalOpen(true);

      const percent = (score / maxScore) * 100;

      if (percent > 60) {
        setPassed(true);

        let scalesList =
          JSON.parse(localStorage.getItem("completed") || "{}") || {};

        addToStructure(scalesList, {
          course_id: moduleInfo.course_id,
          id: moduleInfo.id,
        });

        let newModule = JSON.parse(
          localStorage.getItem("module_files") || "[]"
        );

        try {
          directus.request(
            createItem("Course_History", {
              email: localStorage.getItem("email"),
              url: "/modules/module",
              course: localStorage.getItem("courseInfo"),
              module: localStorage.getItem("module_files"),
              topic: localStorage.getItem("topic_files"),
              scales: localStorage.getItem("scales"),
              completed: scalesList,
              certificat_completed: localStorage.getItem(
                "certificat_completed"
              ),
              certificat_link: localStorage.getItem("certificat_link"),
              date: JSON.stringify(new Date()),
              my_courses: localStorage.getItem("my_courses"),
              active_course: localStorage.getItem("active_course"),
              form: JSON.stringify({
                age: age,
                gender: gender,
                activity: activity,
                position: position,
              }),
            })
          );

          localStorage.setItem("completed", JSON.stringify(scalesList));
        } catch (error: any) {
          sessionStorage.removeItem("token");
          navigate("/");
        }

        if (newModule["scale"]) {
          newModule["scale"] = newModule["scale"] + 1;
        } else {
          newModule["scale"] = 1;
        }

        localStorage.setItem("module_files", JSON.stringify(newModule));
      } else {
        setPassed(false);
      }
    } else if (nextTest.status === 200) {
      localStorage.setItem("question", JSON.stringify(nextTest.data));

      setTestCount(testCount + 1);
      setQuestionData(nextTest.data);

      setLoader(false);
    }
  }

  useEffect(() => {
    localStorage.setItem("test_count", JSON.stringify(testCount));
  }, [testCount]);

  return (
    <div className="coursesListPage">
      <div className="test">
        <div className="headTestBlock">
          <div className="courseBlockText testBlockText">
            <div>
              <h1>Тест по модулю</h1>
              <div className="headCourseBlockDescription">
                Пройдите тестирование, чтобы получить доступ к следующему модулю
                курса. Общее количество попыток и время прохождение не
                ограниченно.
              </div>
            </div>
            <div className="moduleScaleBox">
              <span>
                Прохождение теста: {testCount} вопросов из{" "}
                {localStorage.getItem("total_question")}
              </span>
              <ProgressScale
                scale={
                  (testCount / Number(localStorage.getItem("total_question"))) *
                  100
                }
              />
            </div>
          </div>
        </div>

        <TestBlock
          question={questionData.question}
          answerList={questionData.answers}
          chosen={(e: boolean) => setUnlockNext(e)}
          chosenAnswerID={(e: any) => setChosenAnswerID(e)}
        />
        <div className="nextTestBox">
          {loader ? (
            <div>
              <ReactLoading
                type="spinningBubbles"
                color="black"
                height={"50px"}
                width={"50px"}
              />
            </div>
          ) : (
            <StyledButton
              text="ОТВЕТИТЬ"
              className={
                unlockNext ? "blueButton" : "greyButton disabledButton"
              }
              onClick={unlockNext ? () => onNextTest() : null}
            />
          )}
        </div>
      </div>

      {finalOpen && (
        <FinalPopUp
          message={
            passed
              ? "Тестирование завершено. Следующий модуль в курсе доступен для изучения."
              : "Тестирование по теме завершено. У Вас не хватило баллов для перехода к следующему модулю курса. Пожалуйста, попробуйте снова!"
          }
        />
      )}
    </div>
  );
};

export default ModuleTestPage;
